import PropTypes from "prop-types"
import React, { useState } from "react"
import styled from "styled-components"

import Layout from "../_shared/components/Layout"
import { useStateValue } from "../_shared/context/AppStateStore"
import AdminApp from "./AdminApp"
import AgencyApp from "./AgencyApp"
import AuthPage from "./AuthPage"

// ----------------------------------------------------------------------------

function _RoutedApp(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    const { className } = props

    // -------------------------------------
    // Hooks (e.g. useState, ...)
    // -------------------------------------

    const [{ user }] = useStateValue()

    // -------------------------------------
    // Memoized values
    // -------------------------------------

    // -------------------------------------
    // Effects
    // -------------------------------------

    // -------------------------------------
    // Component functions
    // -------------------------------------

    function renderApp() {
        if (!user) {
            return <AuthPage />
        } else {
            if (user.role === "admin") {
                return <AdminApp />
            } else if (user.role === "agency") {
                return <AgencyApp />
            }
        }
    }

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    const agencyTabs = []
    const adminTabs = [
        { label: "Agenzie", href: "/" },
        { label: "Stanze", href: "/stanze" },
        { label: "Occupanze", href: "/richieste" },
    ]

    return (
        <Layout
            tabs={
                user?.role
                    ? user.role === "admin"
                        ? adminTabs
                        : agencyTabs
                    : null
            }
            className={`${className} ${user ? user.role : "login-page"}`}
        >
            {renderApp()}
        </Layout>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

_RoutedApp.propTypes = {
    className: PropTypes.string.isRequired,
}

_RoutedApp.defaultProps = {}

// ----------------------------------------------------------------------------

const RoutedApp = styled(_RoutedApp)`
    & {
    }
`
// ----------------------------------------------------------------------------

export default RoutedApp
